import styled from "styled-components";
import colors from "../../../assets/styles/colors";

export const HomeContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HomeContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const HomeRow = styled.div`
  display: grid;
  grid-template-columns: 42px 400px;
  column-gap: 14px;

  & + & {
    margin-top: 20px;
  }
`;

export const HomeIcon = styled.div`
  width: 42px;
  height: 42px;
  background: ${colors.textHyperlink};
  box-shadow: 0px 5px 10px ${colors.bgFilterSelected};
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const HomeFooter = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 20px;
`;
